import React, { useEffect, useState, useRef } from "react";
import { Footer, Navbar } from "../components";
import api from "../utils/base_url";
import { useNavigate } from "react-router-dom";

(function injectFonts() {
  if (document.getElementById("vk-about-fonts")) return;
  const l = document.createElement("link");
  l.id = "vk-about-fonts";
  l.rel = "stylesheet";
  l.href =
    "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400;1,600&family=DM+Sans:wght@300;400;500&family=Dancing+Script:wght@600;700&display=swap";
  document.head.appendChild(l);
})();

/* ═══════════ SVG ICONS (unchanged) ═══════════ */
const IconFounder = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
    <circle cx="28" cy="28" r="28" fill="#4A1F1A" />
    <circle cx="28" cy="22" r="7" fill="#FBF6EF" />
    <path d="M14 44c0-7.732 6.268-14 14-14s14 6.268 14 14" stroke="#FBF6EF" strokeWidth="2.2" strokeLinecap="round" fill="none" />
    <path d="M28 8 C26 5,22 6,22 10 C22 13,25 14,28 12 C31 14,34 13,34 10 C34 6,30 5,28 8Z" fill="#CCA16A" opacity="0.8" />
  </svg>
);
const IconBrand = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
    <circle cx="28" cy="28" r="28" fill="#4A1F1A" />
    <path d="M16 28 Q28 40 40 28" stroke="#FBF6EF" strokeWidth="2" fill="none" strokeLinecap="round" />
    <line x1="28" y1="28" x2="28" y2="40" stroke="#FBF6EF" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M20 21 C18 17,13 18,14 22 C15 25,20 25,20 21Z" fill="#CCA16A" />
    <path d="M36 21 C38 17,43 18,42 22 C41 25,36 25,36 21Z" fill="#CCA16A" />
    <path d="M28 17 C28 14,25 13,25 16 C25 19,28 19,28 17Z" fill="#CCA16A" />
  </svg>
);
const IconDiff = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
    <circle cx="28" cy="28" r="28" fill="#4A1F1A" />
    <circle cx="28" cy="20" r="5" fill="#FBF6EF" />
    <circle cx="18" cy="24" r="4" fill="#FBF6EF" opacity="0.7" />
    <circle cx="38" cy="24" r="4" fill="#FBF6EF" opacity="0.7" />
    <path d="M18 40c0-5.523 4.477-10 10-10s10 4.477 10 10" stroke="#FBF6EF" strokeWidth="2" fill="none" strokeLinecap="round" />
    <path d="M10 42c0-4 3.134-7 7-7" stroke="#FBF6EF" strokeWidth="1.5" fill="none" strokeLinecap="round" opacity="0.55" />
    <path d="M46 42c0-4-3.134-7-7-7" stroke="#FBF6EF" strokeWidth="1.5" fill="none" strokeLinecap="round" opacity="0.55" />
  </svg>
);
const IconMission = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
    <circle cx="28" cy="28" r="28" fill="#4A1F1A" />
    <path d="M28 13 C20 13,13 20,13 28 C13 35,20 43,28 43 C36 43,43 35,43 28 C43 20,36 13,28 13Z" fill="none" stroke="#FBF6EF" strokeWidth="1.8" />
    <line x1="28" y1="15" x2="28" y2="43" stroke="#FBF6EF" strokeWidth="1.4" strokeLinecap="round" />
    <line x1="28" y1="25" x2="22" y2="31" stroke="#FBF6EF" strokeWidth="1.2" strokeLinecap="round" />
    <line x1="28" y1="30" x2="34" y2="36" stroke="#FBF6EF" strokeWidth="1.2" strokeLinecap="round" />
    <circle cx="28" cy="45" r="2.5" fill="#CCA16A" />
  </svg>
);
const IconService = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
    <circle cx="28" cy="28" r="28" fill="#4A1F1A" />
    <path d="M22 38 L22 24 Q22 22 24 22 Q26 22 26 24 L26 20 Q26 18 28 18 Q30 18 30 20 L30 22 Q30 20 32 20 Q34 20 34 22 L34 24 Q34 22 36 22 Q38 22 38 24 L38 34 Q38 40 32 40 L24 40 Q22 40 22 38Z" fill="#FBF6EF" />
    <circle cx="27" cy="30" r="1.5" fill="#CCA16A" />
    <circle cx="31" cy="28" r="1.5" fill="#CCA16A" />
    <circle cx="29" cy="34" r="1.2" fill="#CCA16A" />
  </svg>
);
const SvcBridal = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <circle cx="20" cy="20" r="20" fill="#4A1F1A" />
    <circle cx="20" cy="22" r="8" stroke="#FBF6EF" strokeWidth="2" fill="none" />
    <polygon points="20,10 17,15 20,17 23,15" fill="#CCA16A" />
    <polygon points="17,15 20,17 23,15" fill="#FBF6EF" opacity="0.6" />
    <line x1="20" y1="17" x2="20" y2="14" stroke="#CCA16A" strokeWidth="1.2" />
  </svg>
);
const SvcCelebration = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <circle cx="20" cy="20" r="20" fill="#4A1F1A" />
    <path d="M12 28 L22 16 L28 22 Z" fill="#FBF6EF" />
    <path d="M22 16 L28 22 L26 24 L20 18 Z" fill="#CCA16A" opacity="0.8" />
    <circle cx="28" cy="14" r="2" fill="#CCA16A" />
    <circle cx="32" cy="18" r="1.5" fill="#FBF6EF" opacity="0.7" />
    <circle cx="30" cy="10" r="1.2" fill="#FBF6EF" opacity="0.5" />
    <path d="M26 12 Q29 10 28 14" stroke="#CCA16A" strokeWidth="1.2" fill="none" strokeLinecap="round" />
  </svg>
);
const SvcNatural = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <circle cx="20" cy="20" r="20" fill="#4A1F1A" />
    <path d="M20 10 C13 10,8 16,8 22 C8 27,13 32,20 32 C27 32,32 27,32 22 C32 16,27 10,20 10Z" fill="none" stroke="#FBF6EF" strokeWidth="1.8" />
    <line x1="20" y1="11" x2="20" y2="32" stroke="#FBF6EF" strokeWidth="1.3" strokeLinecap="round" />
    <line x1="20" y1="19" x2="15" y2="24" stroke="#FBF6EF" strokeWidth="1.1" strokeLinecap="round" />
    <line x1="20" y1="23" x2="25" y2="28" stroke="#FBF6EF" strokeWidth="1.1" strokeLinecap="round" />
    <circle cx="20" cy="34" r="2" fill="#CCA16A" />
  </svg>
);
const SvcWorkshop = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <circle cx="20" cy="20" r="20" fill="#4A1F1A" />
    <polygon points="20,11 32,17 20,23 8,17" fill="#FBF6EF" />
    <rect x="17" y="10" width="6" height="3" rx="1" fill="#CCA16A" />
    <path d="M14 19 L14 27 Q14 30 20 30 Q26 30 26 27 L26 19" stroke="#FBF6EF" strokeWidth="1.8" fill="none" strokeLinecap="round" />
    <line x1="30" y1="17" x2="30" y2="25" stroke="#CCA16A" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="30" cy="26" r="1.5" fill="#CCA16A" />
  </svg>
);
const PillarArtist = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <circle cx="20" cy="20" r="20" fill="#4A1F1A" />
    <rect x="18" y="9" width="5" height="12" rx="2" fill="#FBF6EF" />
    <rect x="18" y="21" width="5" height="4" rx="1" fill="#CCA16A" opacity="0.8" />
    <circle cx="14" cy="30" r="2" fill="#FBF6EF" opacity="0.7" />
    <circle cx="20" cy="32" r="2" fill="#FBF6EF" />
    <circle cx="26" cy="30" r="2" fill="#FBF6EF" opacity="0.7" />
    <circle cx="11" cy="25" r="1.5" fill="#CCA16A" />
    <circle cx="29" cy="25" r="1.5" fill="#CCA16A" />
  </svg>
);
const PillarNatural = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <circle cx="20" cy="20" r="20" fill="#4A1F1A" />
    <path d="M20 9 C13 9,8 15,8 21 C8 27,13 31,20 31 C27 31,32 27,32 21 C32 15,27 9,20 9Z" fill="none" stroke="#FBF6EF" strokeWidth="1.8" />
    <line x1="20" y1="10" x2="20" y2="31" stroke="#FBF6EF" strokeWidth="1.3" strokeLinecap="round" />
    <line x1="20" y1="18" x2="15" y2="23" stroke="#FBF6EF" strokeWidth="1.1" strokeLinecap="round" />
    <line x1="20" y1="22" x2="25" y2="27" stroke="#FBF6EF" strokeWidth="1.1" strokeLinecap="round" />
    <circle cx="20" cy="33" r="2" fill="#CCA16A" />
  </svg>
);
const PillarBridal = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <circle cx="20" cy="20" r="20" fill="#4A1F1A" />
    <circle cx="20" cy="22" r="8" stroke="#FBF6EF" strokeWidth="1.8" fill="none" />
    <polygon points="20,10 17,15 20,17 23,15" fill="#CCA16A" />
    <polygon points="17,15 20,17 23,15" fill="#FBF6EF" opacity="0.5" />
    <line x1="20" y1="17" x2="20" y2="14" stroke="#CCA16A" strokeWidth="1.2" />
  </svg>
);
const PillarTradition = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <circle cx="20" cy="20" r="20" fill="#4A1F1A" />
    <path d="M20 10 C15 10,11 14,11 19 C11 25,20 32,20 32 C20 32,29 25,29 19 C29 14,25 10,20 10Z" fill="none" stroke="#FBF6EF" strokeWidth="2" />
    <circle cx="20" cy="19" r="4" fill="#CCA16A" />
  </svg>
);
const BadgeNatural = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
    <circle cx="18" cy="18" r="18" fill="#FBF6EF" opacity="0.15" />
    <path d="M18 5 C11 5,5 11,5 18 C5 24,11 31,18 31 C25 31,31 24,31 18 C31 11,25 5,18 5Z" fill="none" stroke="#FBF6EF" strokeWidth="1.6" />
    <line x1="18" y1="6" x2="18" y2="30" stroke="#FBF6EF" strokeWidth="1.2" strokeLinecap="round" />
    <line x1="18" y1="15" x2="13" y2="20" stroke="#FBF6EF" strokeWidth="1" strokeLinecap="round" />
    <line x1="18" y1="19" x2="23" y2="24" stroke="#FBF6EF" strokeWidth="1" strokeLinecap="round" />
    <circle cx="18" cy="32" r="1.8" fill="#CCA16A" />
  </svg>
);
const BadgeHandmade = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
    <circle cx="18" cy="18" r="18" fill="#FBF6EF" opacity="0.15" />
    <path d="M14 26 L14 16 Q14 14 16 14 Q18 14 18 16 L18 13 Q18 11 20 11 Q22 11 22 13 L22 15 Q22 13 24 13 Q26 13 26 15 L26 16 Q26 14 28 14 Q30 14 30 16 L30 23 Q30 28 24 28 L16 28 Q14 28 14 26Z" fill="#FBF6EF" opacity="0.9" />
    <circle cx="19" cy="20" r="1.2" fill="#CCA16A" />
    <circle cx="22" cy="19" r="1.2" fill="#CCA16A" />
  </svg>
);
const BadgeTraditional = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
    <circle cx="18" cy="18" r="18" fill="#FBF6EF" opacity="0.15" />
    <polygon points="18,6 30,18 18,30 6,18" stroke="#FBF6EF" strokeWidth="1.6" fill="none" />
    <polygon points="18,11 25,18 18,25 11,18" stroke="#CCA16A" strokeWidth="1" fill="none" opacity="0.7" />
    <circle cx="18" cy="18" r="3" fill="#FBF6EF" opacity="0.8" />
    <circle cx="18" cy="6" r="1.5" fill="#CCA16A" />
    <circle cx="30" cy="18" r="1.5" fill="#CCA16A" />
    <circle cx="18" cy="30" r="1.5" fill="#CCA16A" />
    <circle cx="6" cy="18" r="1.5" fill="#CCA16A" />
  </svg>
);
const BadgeTrusted = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
    <circle cx="18" cy="18" r="18" fill="#FBF6EF" opacity="0.15" />
    <path d="M18 6 L28 10 L28 20 Q28 27 18 31 Q8 27 8 20 L8 10 Z" stroke="#FBF6EF" strokeWidth="1.6" fill="none" />
    <polyline points="12,18 16,23 24,14" stroke="#CCA16A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);
const LeafBullet = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" style={{ flexShrink: 0, marginTop: "2px" }}>
    <circle cx="11" cy="11" r="11" fill="#4A1F1A" />
    <path d="M11 4 C7 4,4 7,4 11 C4 15,7 18,11 18 C15 18,18 15,18 11 C18 7,15 4,11 4Z" fill="none" stroke="#FBF6EF" strokeWidth="1.2" />
    <line x1="11" y1="4.5" x2="11" y2="17.5" stroke="#FBF6EF" strokeWidth="1" strokeLinecap="round" />
    <line x1="11" y1="10" x2="8" y2="13" stroke="#FBF6EF" strokeWidth="0.9" strokeLinecap="round" />
    <line x1="11" y1="13" x2="14" y2="16" stroke="#FBF6EF" strokeWidth="0.9" strokeLinecap="round" />
  </svg>
);

const Divider = () => (
  <div style={{ display: "flex", alignItems: "center", gap: "10px", margin: "10px 0 18px" }}>
    <div style={{ flex: 1, height: "1px", background: "linear-gradient(to right, transparent, #CCA16A)" }} />
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M9 1 C6 1,1 5,1 9 C1 13,5 17,9 17 C13 17,17 13,17 9 C17 5,13 1,9 1Z" fill="#CCA16A" opacity="0.35" />
      <circle cx="9" cy="9" r="2.5" fill="#CCA16A" />
    </svg>
    <div style={{ flex: 1, height: "1px", background: "linear-gradient(to left, transparent, #CCA16A)" }} />
  </div>
);

const HennaCorner = ({ flip }) => (
  <svg width="200" height="200" viewBox="0 0 200 200" fill="none"
    style={{ position: "absolute", opacity: 0.12, pointerEvents: "none", ...(flip ? { bottom: 0, right: 0, transform: "rotate(180deg)" } : { top: 0, left: 0 }) }}>
    <path d="M10 10 Q90 10 90 90 Q90 170 170 170" stroke="#4A1F1A" strokeWidth="2" fill="none" />
    <path d="M30 10 Q100 10 100 80 Q100 150 170 150" stroke="#4A1F1A" strokeWidth="1.2" fill="none" strokeDasharray="5 7" />
    <circle cx="10" cy="10" r="7" fill="#CCA16A" opacity="0.8" />
    <circle cx="90" cy="90" r="5" fill="#4A1F1A" opacity="0.5" />
    <circle cx="170" cy="170" r="7" fill="#CCA16A" opacity="0.8" />
    <path d="M45 35 Q62 22 58 44 Q54 62 72 56 Q88 50 78 68" stroke="#4A1F1A" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <circle cx="78" cy="68" r="4" fill="#CCA16A" opacity="0.7" />
  </svg>
);

/* Reveal hook */
const useReveal = () => {
  const ref = useRef(null);
  const [v, setV] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setV(true); obs.disconnect(); } },
      { threshold: 0.08 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, v];
};
const rv = (v, d = "0s") => ({
  opacity: v ? 1 : 0,
  transform: v ? "none" : "translateY(36px)",
  transition: `opacity 0.85s ease ${d}, transform 0.85s ease ${d}`,
});

/* ════════════════════════ COMPONENT ════════════════════════ */
const AboutPage = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const go = (id) => navigate("/product", { state: { categoryId: id } });

  useEffect(() => {
    api.get("/categories/")
      .then(r => { if (r.data?.data) setCategories(r.data.data); })
      .catch(console.error);
  }, []);

  const repeated = [...categories, ...categories, ...categories];

  const [heroRef,    heroV]    = useReveal();
  const [nameRef,    nameV]    = useReveal();
  const [founderRef, founderV] = useReveal();
  const [diffRef,    diffV]    = useReveal();
  const [missionRef, missionV] = useReveal();
  const [servRef,    servV]    = useReveal();

  return (
    <>
      <Navbar />
      <main style={{ background: "#FBF6EF", minHeight: "100vh", overflowX: "hidden" }}>

        {/* ══ HERO ══ */}
        <section ref={heroRef} className="vk-hero" style={{ ...rv(heroV) }}>
          {/* Kolam pattern */}
          <svg aria-hidden="true" className="vk-hero-pattern" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="kolam" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
                <circle cx="40" cy="40" r="20" stroke="#4A1F1A" strokeWidth="1" fill="none" />
                <circle cx="40" cy="40" r="12" stroke="#4A1F1A" strokeWidth="0.6" fill="none" />
                <circle cx="40" cy="40" r="3.5" fill="#CCA16A" />
                <line x1="40" y1="20" x2="40" y2="0" stroke="#4A1F1A" strokeWidth="0.6" />
                <line x1="40" y1="60" x2="40" y2="80" stroke="#4A1F1A" strokeWidth="0.6" />
                <line x1="20" y1="40" x2="0" y2="40" stroke="#4A1F1A" strokeWidth="0.6" />
                <line x1="60" y1="40" x2="80" y2="40" stroke="#4A1F1A" strokeWidth="0.6" />
                <circle cx="40" cy="0" r="2.5" fill="#CCA16A" opacity="0.5" />
                <circle cx="40" cy="80" r="2.5" fill="#CCA16A" opacity="0.5" />
                <circle cx="0" cy="40" r="2.5" fill="#CCA16A" opacity="0.5" />
                <circle cx="80" cy="40" r="2.5" fill="#CCA16A" opacity="0.5" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#kolam)" />
          </svg>

          <HennaCorner flip={false} />
          <HennaCorner flip={true} />

          {/* border frames */}
          <div className="vk-hero-frame1" />
          <div className="vk-hero-frame2" />

          {/* corner diamonds */}
          {[{ top:"14px",left:"14px" },{ top:"14px",right:"14px" },{ bottom:"14px",left:"14px" },{ bottom:"14px",right:"14px" }].map((pos,i)=>(
            <svg key={i} width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ position:"absolute", ...pos }}>
              <polygon points="8,0 16,8 8,16 0,8" fill="#CCA16A" opacity="0.6" />
              <circle cx="8" cy="8" r="2.5" fill="#F5ECD7" />
            </svg>
          ))}

          <div className="vk-hero-content">
            {/* EST line */}
            <div className="vk-hero-est">
              <div style={{ width:"48px", height:"1px", background:"#CCA16A" }} />
              <p className="vk-est-text">Est. with love &amp; tradition</p>
              <div style={{ width:"48px", height:"1px", background:"#CCA16A" }} />
            </div>

            {/* Logo */}
            <div style={{ display:"flex", justifyContent:"center", marginBottom:"30px" }}>
              <img src="/Logo.png" alt="Vannakkarangal" className="vk-hero-logo" />
            </div>

            <p className="vk-hero-tagline">Rooted in Tradition, Made with Love</p>
            <p className="vk-hero-sub">Where Tamil heritage meets the art of henna — from our hands to yours.</p>

            {/* leaf motif */}
            <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:"10px" }}>
              <div style={{ width:"40px", height:"1px", background:"#CCA16A", opacity:0.7 }} />
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                <path d="M11 2 C7 2,2 6,2 11 C2 16,6 20,11 20 C16 20,20 16,20 11 C20 6,16 2,11 2Z" fill="none" stroke="#CCA16A" strokeWidth="1.2" />
                <line x1="11" y1="3" x2="11" y2="19.5" stroke="#CCA16A" strokeWidth="1" strokeLinecap="round" />
                <line x1="11" y1="10" x2="7.5" y2="13.5" stroke="#CCA16A" strokeWidth="0.9" strokeLinecap="round" />
                <line x1="11" y1="13.5" x2="14.5" y2="17" stroke="#CCA16A" strokeWidth="0.9" strokeLinecap="round" />
                <circle cx="11" cy="21" r="1.8" fill="#CCA16A" />
              </svg>
              <div style={{ width:"40px", height:"1px", background:"#CCA16A", opacity:0.7 }} />
            </div>
          </div>

          {/* wave to next section */}
          <svg aria-hidden="true" style={{ position:"absolute", bottom:-1, left:0, width:"100%", display:"block" }} viewBox="0 0 1440 60" preserveAspectRatio="none">
            <path d="M0,0 C360,60 1080,0 1440,60 L1440,60 L0,60Z" fill="#4A1F1A" />
          </svg>
        </section>

        {/* ══ HOW WE NAMED ══ */}
        <section ref={nameRef} className="vk-dark-section" style={{ ...rv(nameV) }}>
          <div style={{ position:"absolute", inset:0, opacity:0.07, backgroundImage:"radial-gradient(#CCA16A 1.5px,transparent 1.5px)", backgroundSize:"28px 28px" }} />
          <div className="vk-section-inner" style={{ textAlign:"center", position:"relative" }}>
            <div style={{ display:"flex", justifyContent:"center", marginBottom:"16px" }}><IconBrand /></div>
            <p style={{ ...lbl, color:"#CCA16A", marginBottom:"8px" }}>The Name Behind the Brand</p>
            <h2 style={{ ...h2, color:"#FBF6EF", marginBottom:"6px" }}>How We Named Our Brand?</h2>
            <Divider />
            <div className="vk-name-words">
              {[{word:"Vannam",meaning:"Color · Stain · Beauty"},{word:"+",meaning:""},{word:"Karangal",meaning:"Hands · Artistry"}].map((it,i)=>(
                <div key={i} style={{ textAlign:"center" }}>
                  <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:it.word==="+"?"2.8rem":"2rem", fontWeight:700, color:"#CCA16A", lineHeight:1 }}>{it.word}</div>
                  {it.meaning&&<div style={{ fontFamily:"'DM Sans',sans-serif", fontSize:"0.78rem", color:"rgba(251,246,239,0.6)", marginTop:"6px", letterSpacing:"1px" }}>{it.meaning}</div>}
                </div>
              ))}
            </div>
            <p style={{ ...bd, color:"rgba(251,246,239,0.82)", textAlign:"center" }}>
              Together, they represent the artistry of <strong style={{ color:"#CCA16A" }}>marudhani-stained hands</strong>. What began as a mehendi-focused brand has grown into a space that celebrates natural beauty and our farming roots. Coming from a <strong style={{ color:"#CCA16A" }}>farmer's family</strong>, we bring authentic heartfelt products — a reflection of <strong style={{ color:"#CCA16A" }}>Tamil culture</strong>, tradition.
            </p>
          </div>
        </section>

        {/* ══ FOUNDER ══ */}
        <section ref={founderRef} className="vk-light-section" style={{ ...rv(founderV) }}>
          <div style={{ display:"flex", justifyContent:"center", marginBottom:"14px" }}><IconFounder /></div>
          <p style={{ ...lbl, textAlign:"center", marginBottom:"6px" }}>Founder's Corner</p>
          <h2 style={{ ...h2, textAlign:"center", marginBottom:"8px" }}>The Vision Behind the Brand</h2>
          <Divider />

          {/* Founder card — uses CSS class for flex-direction flip on mobile */}
          <div className="vk-founder-card">
            {/* Photo panel */}
            <div className="vk-founder-left">
              <div className="vk-founder-img-wrap">
                <img src="./assets/Profile.jpeg" alt="Vidhya Velusamy" style={{ width:"100%", height:"100%", objectFit:"cover" }} />
              </div>
              <div className="vk-founder-ring" />
              <div className="vk-founder-name-wrap">
                <p className="vk-founder-name">Vidhya Velusamy</p>
                <p className="vk-founder-role">Founder &amp; Visionary</p>
              </div>
            </div>

            {/* Quote panel */}
            <div className="vk-founder-right">
              <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:"6rem", lineHeight:0.8, color:"#4A1F1A", opacity:0.1, marginBottom:"16px", userSelect:"none" }}>"</div>
              <p className="vk-founder-quote">
                A woman with the vision of creating her own identity began this journey as a hobby, which slowly transformed into a brand. Today, with <strong>determination</strong>, <strong>learning</strong>, and <strong>consistency</strong>, the journey continues towards building <strong style={{ color:"#4A1F1A" }}>Vannakkarangal</strong> into a remarkable brand.
              </p>
              <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
                <div style={{ width:"36px", height:"2px", background:"#CCA16A" }} />
                <span className="vk-founder-sig">Vidhya Velusamy</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="#CCA16A"><path d="M8 14s-6-4.35-6-8a4 4 0 0 1 6-3.45A4 4 0 0 1 14 6c0 3.65-6 8-6 8z"/></svg>
              </div>
            </div>
          </div>
        </section>

        {/* ══ WHAT MAKES US DIFFERENT ══ */}
        <section ref={diffRef} className="vk-diff-section" style={{ ...rv(diffV) }}>
          <div style={{ display:"flex", justifyContent:"center", marginBottom:"14px" }}><IconDiff /></div>
          <p style={{ ...lbl, textAlign:"center", marginBottom:"6px" }}>Our Difference</p>
          <h2 style={{ ...h2, textAlign:"center", marginBottom:"8px" }}>What Makes Us Different?</h2>
          <Divider />
          <div className="vk-diff-box">
            <p style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:"1.15rem", fontStyle:"italic", color:"#4A1F1A", marginBottom:"14px", fontWeight:600 }}>Created from Real Customer Experience</p>
            <p style={bd}>Before starting <strong style={bld}>Vannakkarangal</strong>, the journey began as a customer searching for truly quality, natural, and trustworthy products. The struggle of finding authentic items <strong style={bld}>without chemicals, confusion, or disappointment</strong> became the biggest inspiration behind this brand.</p>
            <p style={{ ...bd, marginBottom:0 }}>Every product at <strong style={bld}>Vannakkarangal</strong> is chosen and created with the thought that customers should never face the same struggles — <strong style={bld}>genuine quality, trust, tradition</strong>, and a heartfelt experience with every purchase.</p>
          </div>
          <div className="vk-pillars-grid">
            {[
              { Icon:PillarArtist,    label:"Experienced Artists", desc:"Skilled in traditional Tamil mehndi patterns" },
              { Icon:PillarNatural,   label:"100% Natural",        desc:"Zero chemicals, pure henna & herbs only" },
              { Icon:PillarBridal,    label:"Bridal Specialists",  desc:"Every bride deserves her perfect story" },
              { Icon:PillarTradition, label:"Rooted in Tradition", desc:"Farmer family values in every product" },
            ].map(({ Icon, label:l2, desc }, i) => (
              <div key={i} className="vk-pillar-card"
                onMouseEnter={e=>{ e.currentTarget.style.transform="translateY(-5px)"; e.currentTarget.style.boxShadow="0 12px 30px rgba(74,31,26,0.14)"; }}
                onMouseLeave={e=>{ e.currentTarget.style.transform="none"; e.currentTarget.style.boxShadow="0 4px 16px rgba(74,31,26,0.06)"; }}>
                <div style={{ display:"flex", justifyContent:"center", marginBottom:"12px" }}><Icon /></div>
                <p style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:"1.05rem", fontWeight:700, color:"#4A1F1A", margin:"0 0 6px" }}>{l2}</p>
                <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:"0.78rem", color:"#8A4B27", margin:0, lineHeight:1.5 }}>{desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ══ MISSION ══ */}
        <section ref={missionRef} className="vk-dark-section" style={{ textAlign:"center", ...rv(missionV) }}>
          <div style={{ position:"absolute", inset:0, opacity:0.05, backgroundImage:"radial-gradient(#FBF6EF 1px,transparent 1px)", backgroundSize:"22px 22px" }} />
          <div className="vk-section-inner" style={{ position:"relative" }}>
            <div style={{ display:"flex", justifyContent:"center", marginBottom:"16px" }}><IconMission /></div>
            <p style={{ ...lbl, color:"#CCA16A", marginBottom:"8px" }}>Our Mission</p>
            <h2 style={{ ...h2, color:"#FBF6EF", marginBottom:"8px" }}>True Beauty Comes From Nature</h2>
            <Divider />
            <div style={{ marginTop:"24px", textAlign:"left", display:"inline-block", width:"100%" }}>
              {["To preserve the ancient art of <strong>henna</strong>","To protect skin <strong>naturally</strong>","To make every celebration more <strong>beautiful</strong>","To provide <strong>chemical-free mehndi</strong>"].map((it,i)=>(
                <div key={i} style={{ display:"flex", alignItems:"flex-start", gap:"12px", marginBottom:"14px" }}>
                  <LeafBullet />
                  <p style={{ ...bd, color:"rgba(251,246,239,0.85)", margin:0 }} dangerouslySetInnerHTML={{ __html:it.replace(/<strong>/g,'<strong style="color:#CCA16A">') }} />
                </div>
              ))}
            </div>
            <p style={{ fontFamily:"'Dancing Script',cursive", fontSize:"1.4rem", color:"#CCA16A", marginTop:"28px", fontWeight:600 }}>
              We believe true beauty comes from nature. ♡
            </p>
          </div>
        </section>

        {/* ══ SERVICES ══ */}
        <section ref={servRef} className="vk-light-section" style={{ ...rv(servV) }}>
          <div style={{ display:"flex", justifyContent:"center", marginBottom:"14px" }}><IconService /></div>
          <p style={{ ...lbl, textAlign:"center", marginBottom:"6px" }}>What We Offer</p>
          <h2 style={{ ...h2, textAlign:"center", marginBottom:"8px" }}>Our Services</h2>
          <Divider />
          <div className="vk-services-grid">
            {[
              { Icon:SvcBridal,      title:"Bridal Mehndi",      desc:"Detailed, intricate designs crafted especially for your most special day." },
              { Icon:SvcCelebration, title:"Celebration Mehndi", desc:"Festivals, engagements, and every joyful event in between." },
              { Icon:SvcNatural,     title:"Natural Products",   desc:"100% pure henna cones & powders — no chemicals, ever." },
              { Icon:SvcWorkshop,    title:"Henna Workshops",    desc:"Learn the art from expert artists. Hands-on, traditional, and fun." },
            ].map(({ Icon, title, desc }, i) => (
              <div key={i} className="vk-service-card">
                <div style={{ marginBottom:"14px" }}><Icon /></div>
                <h3 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:"1.2rem", fontWeight:700, color:"#4A1F1A", margin:"0 0 8px" }}>{title}</h3>
                <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:"0.85rem", color:"#666", lineHeight:1.65, margin:0 }}>{desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ══ FOOTER BADGES ══ */}
        <section style={{ background:"#4A1F1A", padding:"32px 20px" }}>
          <div className="vk-badges-grid">
            {[
              { Icon:BadgeNatural,     title:"Natural",     sub:"Pure & Safe" },
              { Icon:BadgeHandmade,    title:"Handmade",    sub:"Made with Love" },
              { Icon:BadgeTraditional, title:"Traditional", sub:"Inspired by Heritage" },
              { Icon:BadgeTrusted,     title:"Trusted",     sub:"Quality You Can Trust" },
            ].map(({ Icon, title, sub }, i) => (
              <div key={i} style={{ textAlign:"center" }}>
                <div style={{ display:"flex", justifyContent:"center", marginBottom:"8px" }}><Icon /></div>
                <p style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:"1rem", fontWeight:700, color:"#FBF6EF", margin:"0 0 2px" }}>{title}</p>
                <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:"0.72rem", color:"rgba(251,246,239,0.55)", margin:0, letterSpacing:"1px" }}>{sub}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ══ CATEGORY MARQUEE ══ */}
        <section style={{ padding:"60px 0 80px", background:"#FBF6EF" }}>
          <p style={{ ...lbl, textAlign:"center", marginBottom:"8px" }}>Explore</p>
          <h2 style={{ ...h2, textAlign:"center", marginBottom:"8px" }}>Our Collections</h2>
          <Divider />
          <div className="marquee-wrapper-about" style={{ marginTop:"24px" }}>
            <div className="marquee-about">
              {repeated.map((cat,i)=>(
                <div key={i} className="cat-card-about" onClick={()=>go(cat.id)}>
                  <div className="cat-img-about">
                    <img src={cat.category_image||"https://via.placeholder.com/300x200"} alt={cat.category_name} />
                  </div>
                  <div className="cat-label-about"><span>{cat.category_name}</span></div>
                </div>
              ))}
            </div>
          </div>
        </section>

      </main>
      <Footer />

      <style>{`

        /* ════════════════════════════════════
           LAYOUT BLOCKS
        ════════════════════════════════════ */

        .vk-hero {
          background: #F5ECD7;
          position: relative;
          overflow: hidden;
          min-height: 520px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .vk-hero-pattern {
          position: absolute; inset: 0;
          width: 100%; height: 100%;
          opacity: 0.09;
        }
        .vk-hero-frame1 {
          position: absolute; inset: 18px;
          border: 1.5px solid rgba(204,161,106,0.4);
          border-radius: 3px; pointer-events: none;
        }
        .vk-hero-frame2 {
          position: absolute; inset: 27px;
          border: 1px solid rgba(204,161,106,0.18);
          border-radius: 2px; pointer-events: none;
        }
        .vk-hero-content {
          position: relative; z-index: 2;
          text-align: center;
          padding: 70px 32px 80px;
          max-width: 660px; width: 100%;
        }
        .vk-hero-est {
          display: flex; align-items: center;
          justify-content: center; gap: 14px;
          margin-bottom: 34px;
        }
        .vk-est-text {
          font-family: 'DM Sans',sans-serif;
          font-size: 0.68rem; letter-spacing: 4px;
          text-transform: uppercase; color: #8A4B27;
          font-weight: 500; margin: 0;
        }
        .vk-hero-logo {
          height: clamp(64px,10vw,108px);
          width: auto; object-fit: contain;
        }
        .vk-hero-tagline {
          font-family: 'Cormorant Garamond',serif;
          font-size: clamp(1.05rem,2.4vw,1.28rem);
          font-style: italic; color: #7A3A1C;
          margin: 0 auto 14px; font-weight: 400; line-height: 1.65;
        }
        .vk-hero-sub {
          font-family: 'DM Sans',sans-serif;
          font-size: clamp(0.85rem,1.8vw,0.96rem);
          color: #6B3A22; max-width: 430px;
          margin: 0 auto 38px; font-weight: 300;
          line-height: 1.85; opacity: 0.82;
        }

        /* dark bg sections */
        .vk-dark-section {
          background: #4A1F1A;
          padding: 72px 28px;
          position: relative; overflow: hidden;
        }
        /* light bg sections */
        .vk-light-section {
          max-width: 1000px; margin: 0 auto;
          padding: 80px 28px;
        }

        .vk-section-inner {
          max-width: 780px; margin: 0 auto;
        }

        /* Name words row */
        .vk-name-words {
          display: flex; justify-content: center;
          gap: 28px; flex-wrap: wrap;
          margin: 28px 0 32px;
        }

        /* ════ FOUNDER CARD ════ */
        .vk-founder-card {
          display: flex;
          border-radius: 24px; overflow: hidden;
          box-shadow: 0 20px 60px rgba(74,31,26,0.15);
          margin-top: 32px;
        }
        .vk-founder-left {
          flex: 0 0 300px;
          min-height: 400px;
          background: linear-gradient(160deg,#4A1F1A,#4A1F1A);
          display: flex; flex-direction: column;
          align-items: center; justify-content: flex-end;
          padding: 28px 20px;
          position: relative; overflow: hidden;
        }
        .vk-founder-img-wrap {
          position: absolute; top: 28px; left: 50%;
          transform: translateX(-50%);
          width: 170px; height: 170px;
          border-radius: 50%;
          border: 3px solid rgba(204,161,106,0.5);
          overflow: hidden;
          background: rgba(255,255,255,0.07);
        }
        .vk-founder-ring {
          position: absolute; top: 8px; left: 50%;
          transform: translateX(-50%);
          width: 220px; height: 220px;
          border-radius: 50%;
          border: 1px solid rgba(204,161,106,0.25);
        }
        .vk-founder-name-wrap {
          text-align: center; z-index: 1;
          margin-top: 180px;
        }
        .vk-founder-name {
          font-family: 'DM Sans',sans-serif;
          font-size: 1.4rem; font-weight: 500;
          color: #FBF6EF; margin: 0 0 4px;
          text-shadow: 1px 1px 8px rgba(0,0,0,0.4);
        }
        .vk-founder-role {
          font-family: 'DM Sans',sans-serif;
          font-size: 0.72rem; color: #CCA16A;
          letter-spacing: 2.5px; text-transform: uppercase;
          margin: 0; font-weight: 500;
        }
        .vk-founder-right {
          flex: 1 1 300px; background: #fff;
          padding: 48px 40px;
          display: flex; flex-direction: column;
          justify-content: center;
        }
        .vk-founder-quote {
          font-family: 'Cormorant Garamond',serif;
          font-size: clamp(1rem,2.5vw,1.3rem);
          font-style: italic; color: #4A1F1A;
          line-height: 1.8; margin: 0 0 28px;
        }
        .vk-founder-sig {
          font-family: 'Dancing Script',cursive;
          font-size: 1.4rem; color: #4A1F1A; font-weight: 600;
        }

        /* ════ DIFF / PILLARS ════ */
        .vk-diff-section {
          background: #FBF6EF;
          padding: 16px 28px 72px;
          max-width: 960px; margin: 0 auto;
        }
        .vk-diff-box {
          background: #fff; border-radius: 20px;
          padding: 36px 36px 28px;
          box-shadow: 0 8px 30px rgba(74,31,26,0.08);
          margin-bottom: 28px; margin-top: 28px;
        }
        .vk-pillars-grid {
          display: grid;
          grid-template-columns: repeat(4,1fr);
          gap: 16px;
        }
        .vk-pillar-card {
          background: #fff; border-radius: 16px;
          padding: 24px 20px; text-align: center;
          box-shadow: 0 4px 16px rgba(74,31,26,0.06);
          border: 1px solid rgba(204,161,106,0.2);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        /* ════ SERVICES ════ */
        .vk-services-grid {
          display: grid;
          grid-template-columns: repeat(4,1fr);
          gap: 20px; margin-top: 32px;
        }
        .vk-service-card {
          background: #fff; border-radius: 18px;
          padding: 32px 24px;
          box-shadow: 0 4px 20px rgba(74,31,26,0.07);
          border: 1px solid rgba(204,161,106,0.18);
        }

        /* ════ BADGES ════ */
        .vk-badges-grid {
          max-width: 900px; margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(4,1fr);
          gap: 20px; text-align: center;
        }

        /* ════ MARQUEE ════ */
        .marquee-wrapper-about {
          position: relative; overflow: hidden; width: 100%; padding: 10px 0;
          mask-image: linear-gradient(to right, transparent, black 8%, black 92%, transparent);
          -webkit-mask-image: linear-gradient(to right, transparent, black 8%, black 92%, transparent);
        }
        .marquee-about {
          display: flex; gap: 20px;
          animation: scrollLeftAbout 14s linear infinite;
          will-change: transform;
        }
        .marquee-wrapper-about:hover .marquee-about { animation-play-state: paused; }
        @keyframes scrollLeftAbout {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
        .cat-card-about {
          flex-shrink: 0; width: 200px; height: 270px;
          border-radius: 20px; overflow: hidden; cursor: pointer;
          box-shadow: 0 6px 20px rgba(74,31,26,0.12);
          transition: transform 0.35s ease, box-shadow 0.35s ease;
          background: #fff;
        }
        .cat-card-about:hover { transform: translateY(-6px); box-shadow: 0 16px 36px rgba(74,31,26,0.2); }
        .cat-img-about { width: 100%; height: 200px; overflow: hidden; }
        .cat-img-about img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.45s ease; }
        .cat-card-about:hover .cat-img-about img { transform: scale(1.08); }
        .cat-label-about { height: 70px; background: #4A1F1A; display: flex; align-items: center; justify-content: center; padding: 0 12px; text-align: center; }
        .cat-label-about span { font-family: 'Cormorant Garamond',serif; font-size: 1rem; font-weight: 700; color: #FBF6EF; letter-spacing: 0.5px; line-height: 1.3; }

        /* ════════════════════════════════════
           TABLET  ≤ 1024px
        ════════════════════════════════════ */
        @media (max-width: 1024px) {
          .vk-pillars-grid  { grid-template-columns: repeat(2,1fr); }
          .vk-services-grid { grid-template-columns: repeat(2,1fr); }
          .vk-badges-grid   { grid-template-columns: repeat(2,1fr); }
        }

        /* ════════════════════════════════════
           MOBILE  ≤ 768px
        ════════════════════════════════════ */
        @media (max-width: 768px) {

          /* hero */
          .vk-hero { min-height: unset; }
          .vk-hero-content { padding: 56px 20px 68px; }
          .vk-hero-est { gap: 10px; }
          .vk-est-text { font-size: 0.6rem; letter-spacing: 2.5px; }
          .vk-hero-tagline { font-size: 1.05rem; }
          .vk-hero-sub { font-size: 0.85rem; margin-bottom: 28px; }

          /* dark/light sections padding */
          .vk-dark-section { padding: 52px 18px; }
          .vk-light-section { padding: 52px 18px; }
          .vk-diff-section  { padding: 12px 18px 52px; }

          /* name words */
          .vk-name-words { gap: 16px; }

          /* founder card: stack vertically */
          .vk-founder-card { flex-direction: column; }

          .vk-founder-left {
            flex: none; width: 100%;
            min-height: 300px;
            padding: 20px;
          }
          .vk-founder-img-wrap {
            width: 130px; height: 130px;
            top: 24px;
          }
          .vk-founder-ring {
            width: 175px; height: 175px;
            top: 5px;
          }
          .vk-founder-name-wrap { margin-top: 148px; }
          .vk-founder-name { font-size: 1.25rem; }
          .vk-founder-role { font-size: 0.65rem; letter-spacing: 1.8px; }

          .vk-founder-right { padding: 28px 22px; }
          .vk-founder-quote { font-size: 0.98rem; line-height: 1.78; margin-bottom: 20px; }
          .vk-founder-sig   { font-size: 1.2rem; }

          /* diff / pillars */
          .vk-diff-box { padding: 24px 20px; }
          .vk-pillars-grid  { grid-template-columns: repeat(2,1fr); }

          /* services */
          .vk-services-grid { grid-template-columns: 1fr 1fr; gap: 14px; margin-top: 24px; }
          .vk-service-card  { padding: 22px 16px; }

          /* badges */
          .vk-badges-grid { grid-template-columns: repeat(2,1fr); gap: 16px; }

          /* category cards */
          .cat-card-about   { width: 150px; height: 210px; }
          .cat-img-about    { height: 155px; }
          .cat-label-about  { height: 55px; }
          .cat-label-about span { font-size: 0.82rem; }
        }
        @media (max-width: 768px) {
          .vk-hero-logo {
            height: auto !important;
            max-height: 60px !important;
            max-width: 75vw !important;
            width: auto !important;
            object-fit: contain;
          }
          .vk-hero-content {
            width: 100% !important;
            max-width: 100% !important;
            padding-left: 16px !important;
            padding-right: 16px !important;
            overflow: hidden;
            box-sizing: border-box;
          }
        }
        @media (max-width: 480px) {
          .vk-hero-logo {
            max-height: 52px !important;
            max-width: 70vw !important;
          }
}
        /* ════════════════════════════════════
           SMALL MOBILE  ≤ 480px
        ════════════════════════════════════ */
        @media (max-width: 480px) {
          .vk-hero-content { padding: 48px 16px 60px; }

          .vk-pillars-grid  { grid-template-columns: 1fr; }
          .vk-services-grid { grid-template-columns: 1fr; }
          .vk-badges-grid   { grid-template-columns: repeat(2,1fr); }

          .vk-founder-name  { font-size: 1.1rem; }
          .vk-founder-quote { font-size: 0.92rem; }

          .cat-card-about   { width: 135px; height: 195px; }
          .cat-img-about    { height: 142px; }
          .cat-label-about  { height: 53px; }
        }
      `}</style>
    </>
  );
};

/* ── Shared style tokens ── */
const lbl = { fontFamily:"'DM Sans',sans-serif", fontSize:"0.72rem", letterSpacing:"3.5px", textTransform:"uppercase", color:"#4A1F1A", fontWeight:500, margin:0 };
const h2  = { fontFamily:"'Cormorant Garamond',serif", fontSize:"clamp(1.9rem,5vw,2.8rem)", fontWeight:700, color:"#4A1F1A", margin:0, lineHeight:1.15 };
const bd  = { fontFamily:"'DM Sans',sans-serif", fontSize:"0.97rem", color:"#3a2a1a", lineHeight:1.8, marginBottom:"1.2rem" };
const bld = { fontWeight:700, color:"#4A1F1A" };

export default AboutPage;